export default "__VITE_ASSET__c1e4dd46__"